const AppVersion = () =>
  import(
    /* webpackChunkName: "system-app-version" */ '@/pages/system/app-version/index.vue'
  )
const CreateAppVersion = () =>
  import(
    /* webpackChunkName: "system-app-version" */ '@/pages/system/app-version/create.vue'
  )
const EditAppVersion = () =>
  import(
    /* webpackChunkName: "system-app-version" */ '@/pages/system/app-version/edit.vue'
  )

export default {
  path: 'app-version',
  meta: {
    label: 'appVersion',
    auth: 'appVersion'
  },
  component: {
    name: 'AppVersion',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SystemSettingAppVersion',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: AppVersion
    },
    {
      name: 'SystemCreateSettingAppVersion',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateAppVersion
    },
    {
      name: 'SystemEditSettingAppVersion',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditAppVersion,
      props: true
    }
  ]
}
